/** localStorage: DRF token after brand-offers admin login */
export const BRAND_OFFERS_ADMIN_TOKEN_STORAGE_KEY =
  'brand_offers_admin_token' as const;

/** sessionStorage: display label for admin chrome */
export const BRAND_OFFERS_ADMIN_USER_STORAGE_KEY =
  'brand_offers_admin_user' as const;

/** Dispatched when token is cleared (e.g. 401) so React state stays in sync */
export const BRAND_OFFERS_ADMIN_AUTH_CHANGED_EVENT =
  'slayd:brand-offers-admin-auth-changed' as const;
